import { render, staticRenderFns } from "./edit-invoice-date.vue?vue&type=template&id=f1e543d0&"
import script from "./edit-invoice-date.vue?vue&type=script&lang=ts&"
export * from "./edit-invoice-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports